class YGCopyBtn extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
        const button = this;
      button.addEventListener("click", () => {
        const textToCopy = this.dataset.copyText;

        // 使用 Clipboard API 复制文本
        if (navigator.clipboard && navigator.permissions) {
          navigator.clipboard
            .writeText(textToCopy)
            .then(() => {
                if(this.querySelector(".yg-tooltip")) {
                    this.querySelector(".yg-tooltip").style.opacity = "1";
                    setTimeout(() => {
                        this.querySelector(".yg-tooltip").style.opacity = "0";
                    }, 500);
                    }
            })
            .catch((err) => {
              console.error("复制失败:", err);
            });
        } else {
          const textArea = document.createElement("textArea");
          textArea.value = textToCopy;
          textArea.style.width = 0;
          textArea.style.position = "fixed";
          textArea.style.left = "-999px";
          textArea.style.top = "10px";
          textArea.setAttribute("readonly", "readonly");
          document.body.appendChild(textArea);

          textArea.select();
          document.execCommand("copy");
          document.body.removeChild(textArea);
          if(this.querySelector(".yg-tooltip")) {
            this.querySelector(".yg-tooltip").style.opacity = "1";
            setTimeout(() => {
              this.querySelector(".yg-tooltip").style.opacity = "0";
            }, 500);
          }
          
        }
      });
    }
  }

  if (!window.customElements.get("yg-copy-btn")) {
    window.customElements.define("yg-copy-btn", YGCopyBtn);
  }